import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Col, Row, Button, Card } from 'react-bootstrap';
import '../../../assets/css/Recruiter.css';
import '../../../assets/css/Form.css';
import { Header, Footer } from '../../Container';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { jobRequest } from '../../../store/jobOpportunities/async-actions';
import moment from 'moment';
import { Multiselect } from 'multiselect-react-dropdown';
import { ReqPost, ReqGet } from '../../../config/Requests';
import { useParams } from 'react-router-dom';

function JobDetailsClient() {
	const getIdFromPath = pathName => pathName.split('/').reverse()[0];
	const dispatch = useDispatch();
	const jobList = () => dispatch(jobRequest());
	const jobListData = useSelector(state => state.data.jobList);
	// const id = useSelector(state =>
	// 	getIdFromPath(state.router.location.pathname)
	// );
	const error = useSelector(state => state.data.errorMessage);

	const [data, setData] = useState({});
	const startDate = moment(data.start_date).format('MM-DD-YYYY');
	const endDate = moment(data.end_date).format('MM-DD-YYYY');
	const { id } = useParams();
	useEffect(() => {
		ReqGet(`jobs/${id}`)
			.then(({ data }) => {
				setData(data?.data);
			})
			.catch(err => {
				console.log(err.message);
			});
		// if (jobListData === undefined || jobListData.length === 0) {

		ReqGet('jobs', null, {})
			.then(res => {
				if (!res.data.data) {
					// dispatch(jobListRequestFailed('Data not found'));
				} else {
					// dispatch(jobListRequestSuccess(res.data.data));
					return res.data.data;
				}
			})
			.catch(err => {
				dispatch(err.message);
			});

		// console.log(jobListData, id);
		// if (jobListData && id) {
		// 	const index = jobListData.findIndex(item => item.id === parseInt(id))
		// 	if (index === -1) {
		// 		return
		// 	}
		// 	setData(jobListData[index])
		// }
	}, []);
	if (error) {
		return <p>Jobs can't be loaded</p>;
	}
	return (
		<Container fluid='true'>
			<Header type='client' />
			<Container fluid='md'>
				<Row className='justify-content-md-left mt-3 mb-3'>
					<Col className='p-0'>
						<Link to='/'>
							<Button variant='outline-primary btn-back-main'>
								Back to main
							</Button>
						</Link>
					</Col>
				</Row>
				{data && (
					<Row>
						<Col key={data.id} className='p-0'>
							<Card className='mt-3 mb-2 job-view'>
								<Card.Body>
									<Card.Text className='text-job-normal'>
										Client ID #: {data.id}
									</Card.Text>
									<Card.Title className='text-primary small p-1 fw-bold'>
										{data.title}
									</Card.Title>
									<Card.Text className='text-job-orange'>
										Sales Engineer | Requires Travel | Remote
									</Card.Text>
									<Card.Text className='text-job-orange'>
										Requirements
									</Card.Text>
									<Card.Text className='text-job-regular'>General</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										<p>{data.description}</p>
									</Card.Text>

									<Card.Text className='text-job-regular'>
										Specific qualifications
									</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										<p>{data.specific_qualification}</p>
									</Card.Text>

									<Card.Text className='text-job-regular'>
										Destination
									</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										In state:
										{data.destination}
									</Card.Text>

									<Card.Text className='text-job-regular'>Tags</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										<Multiselect
											options={data.tags}
											placeholder=''
											displayValue='display_name'
											selectedValues={data.tags}
											disable='true'
											style={{
												chips: { background: 'blue' },
												searchBox: { border: 'hidden', background: 'white' },
											}}
										/>
									</Card.Text>

									<Card.Text className='text-job-regular'>
										Duration of travel
									</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										{data.travel_duration}
									</Card.Text>

									<Card.Text className='text-job-regular'>
										Security clearance level
									</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										{data.security_level}
									</Card.Text>

									<Card.Text className='text-job-regular'>
										Pay rate range
									</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										{data.start_pay_range}-{data.end_pay_range} per month
									</Card.Text>

									<Card.Text className='text-job-orange'>Dates</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										<span>
											Start Date: &nbsp;
											{startDate}
										</span>
										<br />
										<span>
											End date: &nbsp;
											{endDate}
										</span>
									</Card.Text>

									<Card.Text className='text-job-orange'>Location</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										{/* {data.destination} */}
										{data.job_location == 'remote' && 'Remote'}{' '}
										{data.job_location == 'both' && 'Both'}{' '}
										{data.job_location == 'onsite' && 'On-site'}
									</Card.Text>

									<Card.Text className='text-job-orange'>Job Type</Card.Text>
									<Card.Text className='text-job-normal mb-4'>
										{data.job_type == 'fullTime' && 'Full Time'}{' '}
										{data.job_type == 'halfTime' && 'Half Time'}{' '}
										{data.job_type == 'both' && 'Full & half time'}
									</Card.Text>
								</Card.Body>
							</Card>
						</Col>
					</Row>
				)}
			</Container>
			<Footer />
		</Container>
	);
}

export default JobDetailsClient;
